import { useTheme } from '@mui/system';

/**
 * Renders a preview of the Insight Pro BA Score Over Time chart as an SVG.
 * @component
 * @returns {React.Element}
 */
export const OverTimeChartShowcase = () => {
    const theme = useTheme();

    const medianGrey = theme.palette.overTimeChart.median;
    const portfolioCyan = theme.palette.overTimeChart.showcaseCyan;
    const axisGrey = theme.palette.overTimeChart.medianGreyed;

    return (
        <svg
            width='274'
            height='236'
            viewBox='0 0 274 236'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect width='100%' height='100%' rx='9.75' fill='white' />
            <path
                d='M81 160.5L125.5 122L171 124L215.5 110.5'
                stroke={medianGrey}
                strokeWidth='3'
            />
            <circle
                cx='125.74'
                cy='121.74'
                r='7.2399'
                fill={medianGrey}
                stroke='white'
            />
            <circle
                cx='170.74'
                cy='123.74'
                r='7.2399'
                fill={medianGrey}
                stroke='white'
            />
            <circle
                cx='215.74'
                cy='110.74'
                r='7.2399'
                fill={medianGrey}
                stroke='white'
            />
            <circle
                cx='80.7399'
                cy='160.74'
                r='7.2399'
                fill={medianGrey}
                stroke='white'
            />
            <path
                d='M81 135L126 150L171 86.5L215.5 79'
                stroke={portfolioCyan}
                strokeWidth='3'
            />
            <circle
                cx='125.74'
                cy='149.74'
                r='7.2399'
                fill={portfolioCyan}
                stroke='white'
            />
            <circle
                cx='170.74'
                cy='86.7399'
                r='7.2399'
                fill={portfolioCyan}
                stroke='white'
            />
            <circle
                cx='215.74'
                cy='78.7399'
                r='7.2399'
                fill={portfolioCyan}
                stroke='white'
            />
            <circle
                cx='80.7399'
                cy='134.74'
                r='7.2399'
                fill={portfolioCyan}
                stroke='white'
            />
            <line x1='48.5' y1='179' x2='48.5' y2='64' stroke={axisGrey} />
            <line x1='43' y1='109.5' x2='48' y2='109.5' stroke={axisGrey} />
            <line x1='43' y1='79.5' x2='48' y2='79.5' stroke={axisGrey} />
            <line x1='43' y1='139.5' x2='48' y2='139.5' stroke={axisGrey} />
            <line x1='43' y1='169.5' x2='48' y2='169.5' stroke={axisGrey} />
            <line x1='171' y1='195' x2='171' y2='190' stroke={axisGrey} />
            <line x1='59' y1='189.5' x2='238' y2='189.5' stroke={axisGrey} />
            <line x1='81' y1='195' x2='81' y2='190' stroke={axisGrey} />
            <line x1='126' y1='195' x2='126' y2='190' stroke={axisGrey} />
            <line x1='216' y1='195' x2='216' y2='190' stroke={axisGrey} />
            {[...Array(4)].map((e, i) => (
                <text
                    x={75 + 45 * i}
                    y={208}
                    key={'Q' + (i + 1)}
                    style={{
                        fill: theme.palette.abbey.lightest,
                        fontWeight: 600,
                        fontSize: 10
                    }}
                >
                    {'Q' + (i + 1)}
                </text>
            ))}
            <circle cx={35} cy={29} r={5} fill={portfolioCyan} />
            <text
                x={47.5}
                y={32}
                style={{
                    fill: portfolioCyan,
                    fontWeight: 700,
                    fontSize: 10
                }}
            >
                Your Portfolio
            </text>
            <circle cx={137.5} cy={29} r={5} fill={medianGrey} />
            <text
                x={150}
                y={32}
                style={{
                    fill: medianGrey,
                    fontWeight: 700,
                    fontSize: 10
                }}
            >
                Small Cap Value
            </text>
            <text
                x={27}
                y={190}
                style={{
                    fill: theme.palette.abbey.lightest,
                    fontWeight: 600,
                    fontSize: 10
                }}
                transform='rotate(270, 27, 182)'
            >
                Behavioral Alpha® Score
            </text>
        </svg>
    );
};
